export default __webpack_public_path__ + "static/media/upgrade-report13.5bde5fb8.png";